import script from "./FiltersComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FiltersComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FiltersComponent.vue?vue&type=style&index=0&id=7f199f36&lang=scss"

const __exports__ = script;

export default __exports__